export default {

    NEWSLETTERS: {
        PAGE: {
            LIST: 'list',
            CARDS: 'cards',
            TUTO: 'tuto'
        },
        CATEGORIES: {
            ALL: 'all',
            SUBSCRIPTIONS: 'subscriptions',
            SPAMS: 'spams',
            AUTO_DELETE: 'auto-delete',
            KEEP: 'keep',
            LATER: 'later'
        },
        ACTIONS: {
            UNSUBSCRIBES: 'unsubscribes',
            DELETE: 'delete',
            KEEP: 'keep',
            LATER: 'later'
        },
        SORT: {
            NOT_SET: 'notSet',
            ASCENDING: 'ascending',
            DESCENDING: 'descending',
            MOST_OPEN: 'mostOpen',
            LEAST_OPEN: 'leastOpen',
            UP_TO_DATE: 'upToDate',
            OLDEST: 'oldest'
        },
        CARDS: {
            MARKET: 'market',
            SHARING: 'sharing',
            SUBSCRIPTIONS: 'subscriptions',
            ANIMATION: 'animation',
            LATER: 'later'
        },
        SEARCHING_MODE: {
            UNACTIVE: 'unactive',
            SEARCHING: 'searching',
            RESULT: 'result'
        },
        SPECIALS: {
            USED_FOXY_CARD_ANIMATIONA: 'usedFoxyCardAnimationA',
            USED_FOXY_CARD_ANIMATIONB: 'usedFoxyCardAnimationB'
        }
    },
    NOTIFICATIONS: {
        DEFAULT: 'default',
        GRANTED: 'granted',
        DENIED: 'denied'
    },
    STEPS: {
        TUTO: {
            UNSUBSCRIBES: 'unsubscribes',
            DELETE: 'delete',
            KEEP: 'keep',
            SPAMS: 'spams',
            LATER: 'later',
            END: 'end'
        }
    },
    LOGIN_STATUS: {
        CREATED: 'created',
        ASSOCIATED: 'associated',
        IMPORTED: 'imported',
        RECONNECTED: 'reconnected',
        RECONNECTED_INVALID_GRANT: 'reconnected-invalid-grant',
        MAGIC_LINK: 'magic-link'
    },
    FETCH_STATUS: {
        DONE: 'done',
        PENDING: 'pending',
        PARTIAL: 'partial',
        INITIAL: ''
    },
    DIRECTIONS: {
        UP: 'up',
        RIGHT: 'right',
        DOWN: 'down',
        LEFT: 'left'
    },
    LOGIN_FLOW_GOOGLE: {
        STEPS: {
            DOUBLE_AUTH: 'double_auth',
            APP_PASS: 'app_pass',
            LOGIN: 'login'
        },
        ACTIONS: {
            OPEN_DOUBLE_AUTH: 'open_double_auth',
            OPEN_APP_PASS: 'open_app_pass',
            VALID_DOUBLE_AUTH: 'valid_double_auth',
            VALID_APP_PASS: 'valid_app_pass',
            LOGIN: 'login',
            BACK: 'back'
        }
    },
    abTest: {
        A: 'a',
        B: 'b'
    },
    FIREBASE: {
        LANDING_WITHOUT_QR_CODE: 'landing_without_qr_code_web'
    },
    STORAGE: {
        IS_SHUTDOWN_EMAIL: 'isShutdownEmail'
    },
    STATS: {
        CARROUSEL: {
            FOREST: 'forest',
            MAILBOX: 'mailbox',
            EARTH: 'earth',
            PLANE: 'plane'
        }
    },
    SEASONAL: {
        WINTER: {
            WINTER_SKI: 'winterSki',
            WINTER_SNOWMAN: 'winterSnowman'
        },
        HALLOWEEN: 'halloween'
    },
    HELP: {
        FEATURES: {
            SORT_DURING_SCAN: 'sort_during-scan',
            DELETED_MAILS: 'new_deleted_mail',
            NEW_SENDERS: 'new_senders',
            SORT_LATER: 'sort_later',
            REVERSE_ACTION: 'reverse_action',
            ACTIONS: 'actions'
        }
    },
    HIGHLIGHT: {
        NEW_SENDER: 'cleaning_tooltip_help_sort_later_icon',
        NOT_SEEN: 'cleaning_tooltip_help_after_scan',
        LATER_CTA: 'cleaning_tooltip_help_sort_later_button'
    },
    CONSENT_VERSION: {
        A: 'a',
        B: 'b'
    }
}
